import { ExaminationResponse, Method, Examination } from 'typings/entities/examination';

export const examinations = ({ data }: { data: ExaminationResponse }): ExaminationResponse => data;

export const examination = ({ data }: { data: Examination }): Examination => data;

export const examinationMethod = ({ data }: { data: Method[] }): Method[] => data;
